(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-shared/invitation/assets/javascripts/invitation.js') >= 0) return;  svs.modules.push('/components/marketplace-shared/invitation/assets/javascripts/invitation.js');

'use strict';

let trinidad;
let jupiter;
let parseValue;
if (svs.isServer) {
  trinidad = require('trinidad-core').core;
  parseValue = require('../../../../lb-utils/parse-value/assets/javascripts/parse-value.es6');
  jupiter = trinidad.jupiter;
} else {
  parseValue = svs.components.lbUtils.parseValue.parseValue;
  jupiter = svs.core.jupiter;
}


const lzwEncode = s => {
  const dict = {};
  const data = "".concat(s).split('');
  const out = [];
  let currChar;
  let phrase = data[0];
  let code = 256;
  for (let i = 1; i < data.length; i++) {
    currChar = data[i];
    if (dict[phrase + currChar] !== undefined) {
      phrase += currChar;
    } else {
      out.push(phrase.length > 1 ? dict[phrase] : phrase.charCodeAt(0));
      dict[phrase + currChar] = code;
      code++;
      phrase = currChar;
    }
  }
  out.push(phrase.length > 1 ? dict[phrase] : phrase.charCodeAt(0));
  for (let i = 0; i < out.length; i++) {
    out[i] = String.fromCharCode(out[i]);
  }
  return out.join('');
};

const lzwDecode = s => {
  const dict = {};
  const data = "".concat(s).split('');
  let currChar = data[0];
  let oldPhrase = currChar;
  const out = [currChar];
  let code = 256;
  let phrase;
  for (let i = 1; i < data.length; i++) {
    const currCode = data[i].charCodeAt(0);
    if (currCode < 256) {
      phrase = data[i];
    } else {
      phrase = dict[currCode] ? dict[currCode] : oldPhrase + currChar;
    }
    out.push(phrase);
    currChar = phrase.charAt(0);
    dict[code] = oldPhrase + currChar;
    code++;
    oldPhrase = phrase;
  }
  return out.join('');
};

const b64enc = str => {
  if (svs.isServer) {
    const buffer = Buffer.from(str, 'utf8');
    return buffer.toString('base64');
  }
  return btoa(str);
};

const b64dec = str => {
  if (svs.isServer) {
    const buffer = Buffer.from(str, 'base64');
    return buffer.toString('utf8');
  }
  return atob(str);
};

const encodeInitiationLink = function (service, invitationId) {
  let competitionId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let teamId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  let teamName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  try {
    const b64 = b64enc([service, invitationId, competitionId, teamId, teamName].join(';'));
    const lzw = lzwEncode(b64);
    return lzw;
  } catch (e) {
    throw new Error('Could not encode link');
  }
};

const decodeInitiationLink = link => {
  const data = {};
  try {
    const b64 = lzwDecode(link);
    const values = b64dec(b64).split(';').map(value => {
      switch (value) {
        case 'false':
          return false;
        case 'true':
          return true;
        case 'null':
          return null;
        case 'undefined':
          return undefined;
        default:
          return value;
      }
    });
    const defined = [{
      key: 'service',
      parse: v => parseValue(v).asAlphaNumericDash()
    }, {
      key: 'invitationId',
      parse: v => parseValue(v).asAlphaNumericDash()
    }, {
      key: 'competitionId',
      parse: v => parseValue(v).asAlphaNumericDash()
    }, {
      key: 'teamId',
      parse: v => parseValue(v).asAlphaNumericDash()
    }, {
      key: 'teamName',
      parse: v => parseValue(v).asSafeString()
    }];
    while (values.length && defined.length) {
      const value = values.shift();
      const def = defined.shift();
      if (value) {
        data[def.key] = def.parse(value);
      }
    }
  } catch (e) {
    throw new Error('Could not decode link');
  }
  return data;
};
const getCompetitions = () => new Promise((resolve, reject) => {
  jupiter.get('/competition/1/competitions', response => {
    resolve(response.competitions);
  }, error => {
    reject(error);
  });
});
const getPlayerCompetitions = () => new Promise((resolve, reject) => {
  jupiter.get('/player/1/competitions', response => {
    resolve(response.competitions);
  }, error => {
    reject(error);
  });
});
const isPlayerParticipating = async competitionId => {
  let isParticipating = false;
  try {
    const playerCompetitions = await getPlayerCompetitions();
    for (let i = 0; i < playerCompetitions.length; i++) {
      if (String(playerCompetitions[i].competitionId) === String(competitionId)) {
        isParticipating = true;
        break;
      }
    }
  } catch (e) {}
  return isParticipating;
};
const signup = competitionId => new Promise((resolve, reject) => {
  jupiter.put({
    path: "/competition/2/competitions/".concat(competitionId, "/participations"),
    data: {
      signupType: 'PARTICIPATE',
      locationId: 0
    }
  }, () => {
    resolve();
  }, error => reject(error));
});
const joinTeam = (competitionId, teamId, invitationId) => new Promise((resolve, reject) => {
  jupiter.put({
    path: "/competition/2/competitions/".concat(competitionId, "/teamInvitationResponse"),
    data: {
      invitationId,
      teamId: parseInt(teamId, 10),
      accept: true
    }
  }, response => resolve(response), err => {
    reject(err);
  });
});
const isParticipationInterval = competitionId => new Promise(resolve => {
  let retries = 0;
  const intervalId = setInterval(async () => {
    const isParticipating = await isPlayerParticipating(competitionId);
    if (isParticipating) {
      clearInterval(intervalId);
      resolve(true);
    }
    retries++;
    if (retries >= 10) {
      clearInterval(intervalId);
      resolve(false);
    }
  }, 2000);
});
const join = async (competitionId, teamId, invitationId, onSignUp) => {
  const resp = {
    hasSignedUp: false,
    joinTeamResp: undefined
  };
  const participating = await isPlayerParticipating(competitionId);
  if (!participating) {
    await signup(competitionId);
    resp.hasSignedUp = await isParticipationInterval(competitionId);
    if (!resp.hasSignedUp) {
      throw new Error('we could not participate or jointeam');
    }
    if (typeof onSignUp === 'function') {
      onSignUp();
    }
  }
  resp.joinTeamResp = await joinTeam(competitionId, teamId, invitationId);
  return resp;
};
const invitationExports = {
  decodeInitiationLink,
  encodeInitiationLink,
  getCompetitions,
  getPlayerCompetitions,
  join
};
if (svs.isServer) {
  module.exports = invitationExports;
} else {
  setGlobal('svs.components.marketplaceShared.invitation', invitationExports);
}

 })(window);